import { datadogRum } from "@datadog/browser-rum";
import { parseISO } from "date-fns";

// billing amounts are formatted like $500.00, we need it to be "500"
export const convertCurrencyToIntString = (amount) => {
  if (!amount) return "";
  return Number(amount.replace(/[^0-9.-]+/g, "")).toFixed(0);
};

export const daysUntilTrialEnds = (trialEndDate) => {
  if (!trialEndDate || trialEndDate === null) return "";

  const today = new Date();
  const endDate = parseISO(trialEndDate);
  // NOTE: We define oneDay to be the number of milliseconds
  // in a day (24h * 60m * 60s * 1000ms)
  const oneDay = 86400000;

  return Math.round((endDate.getTime() - today.getTime()) / oneDay);
};

export const formatCurrency = (amount, currencyCode) => {
  if (currencyCode === "") return amount;

  const formatter = new Intl.NumberFormat("en-US", {
    currency: currencyCode,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    style: "currency",
  });

  return formatter.format(amount);
};

// For React Datadog Real User Management logging
export const initializeDatadogRUM = () => {
  if (
    process.env.REACT_APP_DATADOG_CLIENT_TOKEN &&
    process.env.REACT_APP_DATADOG_RUM_APP_ID
  ) {
    datadogRum.init({
      applicationId: process.env.REACT_APP_DATADOG_RUM_APP_ID,
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
      env: process.env.RAILS_ENV,
      service: "recognition",
      sampleRate: 100,
    });
  }
};

// used for rails endpoints that return an array of errors with message
export const handleErrorsArray = (error) => {
  let errors;
  if (error.response) {
    errors =
      error.response.data.errors &&
      error.response.data.errors
        .map((err) => {
          return err.message;
        })
        .join(", ");
  } else {
    errors = error.message;
  }
  datadogRum.addError(new Error(errors));
  return errors;
};

export const downloadFile = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const removeQueryParams = (url) => {
  return url.split("?")[0];
};

export const onAdminPage = (currentLocation) => {
  const location = removeQueryParams(currentLocation);

  // NOTE: most admin pages start with /company and /admin but there are a few user pages that also start with /company
  // that we dont want flagged as admin pages:
  //   view profile: /company/users/60f4ca36983d500069cc7057
  //   rewards history: /company/rewards/my_rewards

  return (
    location === "/company/users" ||
    location === "/company/rewards" ||
    location === "/company/rewards/totals_report" ||
    location.startsWith("/company/users/participation") ||
    location.startsWith("/company/users/bulk_new") ||
    location.startsWith("/company/catalog_items") ||
    location.startsWith("/company/settings/appearance") ||
    location.startsWith("/company/settings/configuration") ||
    location.startsWith("/company/billing") ||
    location.startsWith("/company/accounts") ||
    location.startsWith("/company/reports") ||
    location.startsWith("/company/imported") ||
    location.startsWith("/company/bonus") ||
    location.startsWith("/company/settings/integrations") ||
    location.startsWith("/company/integrations") ||
    location.startsWith("/admin") ||
    location.startsWith("/analytics/budget_utilization")
  );
};

export const onSuperAdminPage = (currentLocation) => {
  // NOTE: all super admin pages start with /super_admin or /tech_ops
  return (
    currentLocation.startsWith("/super_admin") ||
    currentLocation.startsWith("/tech_ops")
  );
};
